export enum DonationTarget {
  CHARITY = 1,
  CAMPAIGN = 2,
  ORPHAN = 3,
}

export const getDonationTargetColor = (status: DonationTarget) => {
  switch (status) {
    case DonationTarget.CHARITY:
      return "green";
    case DonationTarget.ORPHAN:
      return "orange";
    case DonationTarget.CAMPAIGN:
      return "indigo";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getDonationTarget = (status: DonationTarget) => {
  switch (status) {
    case DonationTarget.CHARITY:
      return "charity";
    case DonationTarget.CAMPAIGN:
      return "campaign";
    case DonationTarget.ORPHAN:
      return "orphan";
    default:
      return "not_working";
  }
};

export enum DonationStatus {
  PAID = 1,
  UNPAID = 2,
  REJECT = 3,
}
export const getDonationStatusColor = (status: DonationStatus) => {
  switch (status) {
    case DonationStatus.PAID:
      return "green";
    case DonationStatus.UNPAID:
      return "orange";
    case DonationStatus.REJECT:
      return "indigo";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getDonationStatus = (status: DonationStatus) => {
  switch (status) {
    case DonationStatus.PAID:
      return "paid";
    case DonationStatus.UNPAID:
      return "unpaid";
    case DonationStatus.REJECT:
      return "reject";
    default:
      return "not_working";
  }
};

export enum PeriodRatio {
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  ANNUAL = 4
}
export const getPeriodRatioColor = (status: PeriodRatio) => {
  switch (status) {
    case PeriodRatio.DAILY:
      return "green";
    case PeriodRatio.MONTHLY:
      return "orange";
    case PeriodRatio.WEEKLY:
      return "indigo";
    case PeriodRatio.ANNUAL:
      return "blue";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getPeriodRatio = (status: PeriodRatio) => {
  switch (status) {
    case PeriodRatio.DAILY:
      return "daily";
    case PeriodRatio.MONTHLY:
      return "monthly";
    case PeriodRatio.WEEKLY:
      return "weekly";
    case PeriodRatio.ANNUAL:
      return "annual";
    default:
      return "--";
  }
};